import { useCallback, useEffect, useMemo, useRef, useState } from "react"
import { Form } from "react-router-dom"
import { Button, Input } from "reactstrap"
import WorkplaceFilterSel from "./WorkplaceFilterSel"
import { isEqual, toNumber } from 'lodash';
import WorkplaceTitle from "./WorkplaceTitle"
import { MemberRole, WorkPlaceFilterSel, WorkPlaceCatFilter, WorkPlaceTagFilter, sp_WpFindTag, WpSliceData, WpEmpFilterType, TaskStatus, WpFilterTaskDueMode, WpTitle } from "../../../redux/workplace/wpTypes";
import {
  setActivePostId2, loadPostTitleActionV2, getRoleUnreadCount, setFilterSelected,
  setTaskStatusFilter, setKeywordAction,


} from "../../../redux/workplace/wpActions";
import { changeSelectedChat } from "../../../redux/actions";
import { useRedux } from "hooks"
import { Utils } from "helpers/utils"
import { createSelector } from "reselect"
import { UserTypes } from "../../../api"
import { getRoleUnreadCountApi } from "../../../api/wpapi"
import TextBox from "components/TextBox"
import { APIClient } from "../../../api/apiCore";
import * as urls from "../../../api/urls";
import WorkPlaceFilter from "./WorkplaceFilter"
import WpTagToolBox from "components/FloatingToolbox"
import { debounce, last, set } from "lodash";
import { Const, SKeys } from "const"
import { DbUtils } from "helpers/dbUtils";
import { TABS, WpModes } from "../../../constants";
import { useDialog } from "DialogProvider";
import classnames from "classnames";

// If true, auto-focus the search box only on desktop - skip mobile/tablet so the
// on-screen keyboard doesn't pop up every time the user switches tabs.
const AUTO_FOCUS_DESKTOP_ONLY = true;

const Title = (curUserId: number, wpMode: WpModes) => {
  const { dispatch, useAppSelector } = useRedux();
  const storeData = createSelector(
    (state: any) => state.WpSlice,
    (wp: WpSliceData) => ({
      roleUnread: wp.roleUnread,
    })
  );
  const { roleUnread } = useAppSelector(storeData);

  const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false);
  const totalUnread =
    wpMode === WpModes.Workplace
      ? roleUnread.unreadFlag + roleUnread.unreadFollower + roleUnread.unreadMyPost + roleUnread.unreadOwner + roleUnread.unreadTagMe + roleUnread.unreadOrganize + roleUnread.unreadPersonFollow + roleUnread.unreadObserver
      : roleUnread.taskUnreadMine + roleUnread.taskUnreadAssigner + roleUnread.taskUnreadRequestBy + roleUnread.taskUnreadFlag + roleUnread.taskUnreadRelated + roleUnread.taskUnreadObserver;



  const onNewWpPost = () => {
    const title = wpMode == WpModes.Workplace ? Const.TEXT_NEW_WP_POST : wpMode == WpModes.Task ? Const.TEXT_NEW_WP_TASK : "N/A";
    dispatch(setActivePostId2(wpMode, "", title/*"ตั้งโพสใหม่"*/, "➕", "#000000", "#C0C0C0", "New post"));
    dispatch(changeSelectedChat(null));
  }
  const onHome = () => {
    dispatch(setActivePostId2(wpMode, null, null, null, null, null, "Home"));
    dispatch(changeSelectedChat(null));
  }

  return (
    <div className="d-flex align-items-start">
      <div className="flex-grow-1">

        <h4>
          {/* <img src="/icons/2s-social.png" width="38"></img> */}
          {wpMode === WpModes.Workplace && (<>{Utils.GetMemberRoleIcon(wpMode, MemberRole.All)}2S Workplace</>)}
          {wpMode === WpModes.Task && (<span className="hand" onClick={onHome}>{Utils.GetMemberRoleIcon(wpMode, MemberRole.All)}2S Task</span>)}
          {totalUnread > 0 && (<span className="unread-badge-wp p-2 ms-2">{totalUnread}</span>)}  {/* 20250519 Change total unread count to display here */}

          {/* [{curUserId}] */}
        </h4>
      </div>
      <div className="flex-shrink-0">
        <div id="add-chat-room" title="สร้างหัวข้อใหม่">
          <button type="button" className="btn btn-soft-primary btn-sm" onClick={onNewWpPost}><i className="fas fa-plus"></i></button>
        </div>
      </div>
    </div>
  )
}

interface FilterControlProps {
  keyword: string,
  onKeywordChange: (keyword: string) => void;
  onSearchTitle: (searchNow: boolean) => void;
  searchInputRef?: React.Ref<HTMLInputElement>;
}
const FilterControl = ({ keyword, onKeywordChange, onSearchTitle, searchInputRef }: FilterControlProps) => {
  const onClearKeyword = async () => {
    const txt: any = document.getElementById("serachChatUser");
    if (txt) txt.value = '';
    // debouncePerformSearchContact();
  }
  const onFilterButtonClick = () => {
    // setIsFilterChatRoomModalOpen(true);
    alert('Under Construction');
  }
  const filterIcon = 'bx bx-filter-alt';
  // filterChatRoom.unRead || filterChatRoom.personUnRead || filterChatRoom.noActivity || filterChatRoom.keySelected.length > 0
  //   ? 'bx bxs-filter-alt' : 'bx bx-filter-alt';

  // const [filterText, setFilterText] = useState<string>("");

  const onSearchPost = async () => {
    onSearchTitle(true);
  }

  return (
    <div className="input-group mb-3">
      <TextBox ref={searchInputRef} placeholder="ค้นหา" icon13css="fas fa-search" icon13small={true} value={keyword} onChange={(e) => onKeywordChange(e.target.value)} onEnter13={onSearchPost} />
    </div>
  )
}

interface IndexProps {
  wpMode: WpModes;
}
const Index = ({ wpMode }: IndexProps) => {
  const { dispatch, useAppSelector } = useRedux();
  const storeData = createSelector(
    (state: any) => state.Profile2,
    (state: any) => state.WpSlice,
    (state: any) => state.Layout,
    (p2, wp: WpSliceData, layout) => ({
      curUserId: p2.userId,
      curUserType: p2.userType,
      tagFilterSelected: wpMode == WpModes.Workplace ? wp.tagFilterSelected : wp.tagFilterSelectedTk,
      filterNotClose: wpMode == WpModes.Workplace ? wp.filterNotClose : wp.filterNotCloseTk,
      taskStatusFilter: wp.taskStatusFilter,
      activeTab: layout.activeTab,
      tagUnreadOnSignalR: wp.tagUnreadOnSignalR,
      shareFilterWpTask: wp.shareFilterWpTask,
      keywordFromStore: wpMode == WpModes.Workplace ? wp.keywordWp : wp.keywordTk,
      searchTriggerFromStore: wpMode == WpModes.Workplace ? wp.searchTriggerWp : wp.searchTriggerTk,
    })
  );
  const { curUserId, curUserType, tagFilterSelected, filterNotClose, taskStatusFilter, activeTab, tagUnreadOnSignalR, shareFilterWpTask, keywordFromStore, searchTriggerFromStore } = useAppSelector(storeData);

  const [filterSel, setFilterSel] = useState<WorkPlaceFilterSel[]>(
    [
      // { type: "product", icon: "fas fa-align-justify", text: "GI - ท่อกลม", keyCode: "p1" },
      // { type: "product", icon: "fas fa-align-justify", text: "เชือก", keyCode: "p2" },
      // { type: "product", icon: "fas fa-align-justify", text: "ตะแกรงสาน", keyCode: "p3" },
      // { type: "product", icon: "fas fa-align-justify", text: "ตาข่ายถัก", keyCode: "p4" },
      // { type: "product", icon: "fas fa-align-justify ", text: "ท่อประปา", keyCode: "p5" },
      // { type: "customer", icon: "fas fa-user-alt", text: "สยาม ค้าเหล็ก พัทลุง", keyCode: "c1" },
    ]
  );
  const [showFilterPanel, setShowFilterPanel] = useState<boolean>(window.innerWidth > 1460);
  const [keyword, setKeyword] = useState<string>("");
  const searchInputRef = useRef<HTMLInputElement>(null);
  const cssWorkPlaceFilter = showFilterPanel ? "workplace-filter-show" : "workplace-filter-hide";

  const [allTags, setAllTags] = useState<WorkPlaceCatFilter[]>([]);
  //const [filterUnread, setFilterUnread] = useState<boolean>(false);
  const [filterUnread, setFilterUnread] = useState<boolean>(Utils.Conf_WorkPlaceRememberFilter() && Utils.Conf_WorkPlaceFilterUnread(wpMode));
  const [filterTaskDueMode, setFilterTaskDueMode] = useState<WpFilterTaskDueMode>(WpFilterTaskDueMode.None);
  // const [filterNotClose, setFilterNotClose] = useState<boolean>(true);
  const [selTagIds, setSelTagIds] = useState<number[]>([]);


  const filterUnreadRef = useRef(filterUnread);
  const filterTaskDueModeRef = useRef(filterTaskDueMode);
  const filterNotCloseRef = useRef(filterNotClose);
  const keywordRef = useRef(keyword);
  const selTagIdsRef = useRef(selTagIds);
  const tagFilterSelectedRef = useRef(tagFilterSelected);
  const taskStatusFilterRef = useRef(taskStatusFilter);
  const isFirstSearchTriggerRun = useRef(true);
  // const wpModeRef = useRef(wpMode);


  //const tagCatMatchAll = allTags.filter(t => t.tagMatchedAll).map(t => t.category);
  // const tagCatMatchAll = useMemo(() => {
  //   return allTags.filter(t => t.tagMatchedAll).map(t => t.category).filter(t => tagFilterSelected.some(x => x.category == t));
  // }, [allTags, tagFilterSelected]);
  const [tagCatMatchAll, setTagCatMatchAll] = useState<string[]>([]);
  useEffect(() => {
    const curValue = tagCatMatchAll;
    const newValue = allTags.filter(t => t.tagMatchedAll).map(t => t.category).filter(t => tagFilterSelected.some(x => x.category == t));
    const isSame =
      newValue.length === tagCatMatchAll.length &&
      newValue.every((v, i) => v === tagCatMatchAll[i]);
    if (!isSame) {
      setTagCatMatchAll(newValue);
    }
  }, [allTags, tagFilterSelected]);



  const tagCatMatchAllRef = useRef(tagCatMatchAll);
  useEffect(() => { filterUnreadRef.current = filterUnread; }, [filterUnread]);
  useEffect(() => { filterTaskDueModeRef.current = filterTaskDueMode; }, [filterTaskDueMode]);
  useEffect(() => { filterNotCloseRef.current = filterNotClose; }, [filterNotClose])
  useEffect(() => { keywordRef.current = keyword; }, [keyword]);
  useEffect(() => { selTagIdsRef.current = selTagIds; }, [selTagIds]);
  useEffect(() => { tagFilterSelectedRef.current = tagFilterSelected; }, [tagFilterSelected]);
  useEffect(() => { tagCatMatchAllRef.current = tagCatMatchAll; }, [tagCatMatchAll])
  useEffect(() => { taskStatusFilterRef.current = taskStatusFilter }, [taskStatusFilter]);

  const onToggleFilterPane = async () => {
    setShowFilterPanel(prev => !prev);
  }
  // const onApplyFilter = async () => {
  //   setShowFilterPanel(false);
  // }
  const onApplyFilter = useCallback(async () => {
    setShowFilterPanel(false);
  }, []);

  const onFilterDel = async (tagId: number) => {
    try {
      const updated = (tagFilterSelected ?? []).filter(t => t.tagId !== tagId);
      dispatch(setFilterSelected(wpMode, updated, undefined));
      setAllTags(prev =>
        prev.map(eCat => ({
          ...eCat,
          tags: (eCat.tags ?? []).map(tag => tag.tagId === tagId ? { ...tag, selected: false } : tag)
        }))
      )
      // setFilterSel((prev) =>
      //   prev.filter((e: WorkPlaceFilterSel) => !(e.tagId === tagId))
      // )
      // const filter2 = filterSel.filter((e: WorkPlaceFilterSel) => e.type !== type && e.keyCode !== keyCode);
      // setFilterSel(filter2);
    } catch (e) {
      console.error(e);
      alert((e as any).message);
    }
  }


  // const onToggleCollapse = (cat: string, collapseAll: boolean | null) => {
  //   if (cat === "" && collapseAll !== null) {
  //     setAllTags(prev => prev.map(e => ({ ...e, isCollapse: collapseAll })));
  //   } else {
  //     setAllTags(prev => prev.map(e => e.category === cat ? { ...e, isCollapse: !e.isCollapse } : e));
  //   }
  // }

  const onToggleCollapse = useCallback((cat: string, collapseAll: boolean | null) => {
    if (cat === "" && collapseAll !== null) {
      // collapse/expand all
      setAllTags(prev => prev.map(e => ({ ...e, isCollapse: collapseAll })));
    } else {
      // toggle specific category
      setAllTags(prev => prev.map(e => e.category === cat ? { ...e, isCollapse: !e.isCollapse } : e));
    }
  }, []);


  const fnSetTagToUseState = (caller: string, rs: any) => {

    if (!rs) return;
    rs.forEach((a: any) => {
      a.isCollapse = false;
      a.tagMatchedAll = false;
      a.empFilterType = WpEmpFilterType.Poster;
    });
    setAllTags(rs);
  }

  const fnLoadTagOnStart = async () => {
    // load from local
    try {
      //DbUtils.wp_load_tag_for_filter(curUserId).then(rs => fnSetTagToUseState('local', rs));
      const rsLocal = await DbUtils.wp_load_tag_for_filter(curUserId); // make local finished before calling api bellow
      fnSetTagToUseState('local', rsLocal)
    } catch (e1) {
      Utils.HandleException(e1, false);
    }

    // load from api
    const api = new APIClient();
    api.fnPostForm(urls.WP_LOAD_TAG_FOR_FILTER, { wpMode: wpMode })
      .then(rs => {
        DbUtils.wp_load_tag_for_filter(curUserId, rs);
        fnSetTagToUseState('api', rs);
      })
      .catch(e2 => Utils.HandleException(e2, false));
  }

  useEffect(() => {
    fnLoadTagOnStart();
  }, []);

  const [firstTimeSearchWP, setFirstTimeSearchWP] = useState<boolean>(false);
  const [firstTimeSearchTK, setFirstTimeSearchTK] = useState<boolean>(false);

  const onSearchTitle = async (searchNow: boolean, callFrom: string) => {
    // console.log('onSearchTitle:', {searchNow, callFrom});
    const shouldSearch =
      shareFilterWpTask
      ||
      ((firstTimeSearchWP == false || activeTab == TABS.WORKPLACE) && wpMode == WpModes.Workplace)
      ||
      ((firstTimeSearchTK == false || activeTab == TABS.TASK) && wpMode == WpModes.Task);

    if (!shouldSearch) return;
    if (wpMode == WpModes.Workplace) setFirstTimeSearchWP(true);
    else if (wpMode == WpModes.Task) setFirstTimeSearchTK(true);

    // const includeFilterEmpRelated = allTags.find(e => e.category === Const.WP_CAT_EMP)?.empIncludePostRelated;
    const empFilterType = allTags.find(e => e.category === Const.WP_CAT_EMP)?.empFilterType ?? WpEmpFilterType.Poster;
    if (searchNow) {
      const selTagIds2 = (tagFilterSelected ?? []).map(t => t.tagId);
      const memberRole = Utils.GetMemberRoleFromStorage(wpMode);
      const sortMode = Utils.Conf_WorkPlaceSortMode(wpMode);
      dispatch(setKeywordAction(wpMode, keyword, true));
      dispatch(loadPostTitleActionV2(
        wpMode, keyword, [], memberRole, selTagIds2/*selTagIds*/, filterUnread, filterNotClose, empFilterType/*includeFilterEmpRelated ?? false*/, tagCatMatchAll, "OnSearchTitle", taskStatusFilter,
        null, null, null, null, null, null, null, filterTaskDueMode, sortMode
      ));
    } else {
      onSearchTitleDebounce(empFilterType/*includeFilterEmpRelated*/);
    }
  }

  // 20250818 if click icon unread, then reload all unread without other condition
  const onClickUnreadIcon = async () => {
    try {
      const memberRole = Utils.GetMemberRoleFromStorage(wpMode);
      const sortMode = Utils.Conf_WorkPlaceSortMode(wpMode);
      dispatch(loadPostTitleActionV2(wpMode, "", [], memberRole, null, true, false, WpEmpFilterType.Poster /*includeFilterEmpRelated ?? false*/, null, "onClickUnreadIcon", []
        , null, null, null, null, null, null, null, null, sortMode));
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }


  // const InputDialogContent = ({ onClose }: { onClose: (val: string) => void }) => {
  //   const [txt1, setTxt1] = useState("");

  //   return (
  //     <>
  //       <input
  //         type="text"
  //         value={txt1}
  //         onChange={(e) => setTxt1(e.target.value)}
  //       />
  //       <button onClick={() => onClose(txt1)}>OK</button>
  //     </>
  //   );
  // };

  // const dialog = useDialog();
  // useEffect(() => {
  //   dialog.showCommonInfo({
  //     children: <InputDialogContent onClose={(e) => console.log(e)} />,
  //     title: "Input something"
  //   })
  //     .then(rs => console.log(rs))
  //     .catch(console.error);
  // }, []);

  const onSearchTitleDebounce = useCallback(
    debounce((empFilterType: WpEmpFilterType/*includeFilterEmpRelated*/) => {
      const filterUnread = filterUnreadRef.current;
      const filterTaskDueMode = filterTaskDueModeRef.current;
      const filterNotClose = filterNotCloseRef.current;
      const keyword = keywordRef.current;
      // const selTagIds = selTagIdsRef.current;
      const selTagIds2 = (tagFilterSelectedRef.current ?? []).map(t => t.tagId);
      const taskStatusFilter2 = taskStatusFilterRef.current;

      const memberRole = Utils.GetMemberRoleFromStorage(wpMode);
      const sortMode = Utils.Conf_WorkPlaceSortMode(wpMode);
      dispatch(loadPostTitleActionV2(
        wpMode, keyword, [], memberRole, selTagIds2/*selTagIds*/, filterUnread, filterNotClose, empFilterType/*includeFilterEmpRelated ?? false*/, tagCatMatchAllRef.current, "OnSearchTitleDebounce mode = " + wpMode, taskStatusFilter2,
        null, null, null, null, null, null, null, filterTaskDueMode, sortMode
      ));

      // 20250702 from embedded mode
      const init_wpid = localStorage.getItem(SKeys.InitWpId);
      if (init_wpid) {
        dispatch(setActivePostId2(WpModes.Workplace, init_wpid, null, null, null, null, "Init post from InitWpId (emb mode)"));
        localStorage.removeItem(SKeys.InitWpId);
      }
    }, 300),
    [] // Dependencies are empty so it's only created once
  );

  useEffect(() => {
    if (curUserType == UserTypes.Employee && curUserId > 0) {
      onSearchTitle(false, "User Changed");
      dispatch(getRoleUnreadCount(false));
    }
  }, [curUserType, curUserId]);


  const onClickSearch = async () => {
    onSearchTitle(true, "Click Search");
  }

  // 20260724 mirror the keyword into the store as the user types (not just on actual search)
  // so the other mode's textbox stays in sync while sharing is on (see wpSlice SET_KEYWORD).
  const onKeywordChange = (val: string) => {
    setKeyword(val);
    if (shareFilterWpTask) {
      dispatch(setKeywordAction(wpMode, val));
    }
  }

  useEffect(() => {
    const myTab = wpMode === WpModes.Workplace ? TABS.WORKPLACE : TABS.TASK;
    if (activeTab === myTab && (!AUTO_FOCUS_DESKTOP_ONLY || Utils.IsDesktop())) {
      searchInputRef.current?.focus();
    }
  }, [activeTab, wpMode]);

  const onClickTitle = async (postId: string, postTitle: string, postAbbr: string, postFore: string, postBack: string, titleRow?: WpTitle) => {
    dispatch(setActivePostId2(wpMode, postId, postTitle, postAbbr, postFore, postBack, "Click post title", titleRow ?? null));
  }

  const [tagFilter, setTagFilter] = useState<any[]>([]);

  // const onTagSelect = (cat: string, tagSelected: WorkPlaceFilterSel[]) => {
  //   try {
  //     const combined = [...filterSel, ...tagSelected];
  //     const uniqueMap = new Map<number, WorkPlaceFilterSel>();
  //     combined.forEach(t => {
  //       if (t.cat !== cat || tagSelected.some(n => n.tagId == t.tagId)) {
  //         uniqueMap.set(t.tagId, t);
  //       }
  //     });
  //     const updated = Array.from(uniqueMap.values());
  //     setFilterSel(updated);

  //   } catch (e) {
  //     Utils.HandleException(e, true);
  //   }
  // }

  const onTagSelect = useCallback((cat: string, tagSelected: WorkPlaceFilterSel[]) => {
    try {
      setFilterSel(prev => {
        const combined = [...prev, ...tagSelected];

        const uniqueMap = new Map<number, WorkPlaceFilterSel>();
        combined.forEach(t => {
          if (t.cat !== cat || tagSelected.some(n => n.tagId === t.tagId)) {
            uniqueMap.set(t.tagId, t);
          }
        });

        return Array.from(uniqueMap.values());
      });
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }, []);

  // const setTagSearching = (cat: string, isSearching: boolean) => {
  //   setAllTags(prev => prev.map(e => e.category === cat ? { ...e, isSearching: isSearching } : e));
  // }
  const setTagSearching = useCallback((cat: string, isSearching: boolean) => {
    setAllTags(prev =>
      prev.map(e =>
        e.category === cat ? { ...e, isSearching } : e
      )
    );
  }, []);   // <-- stable  

  // const onSearchTag = (cat: string, filter: string) => {
  //   try {
  //     const api = new APIClient();
  //     setTagSearching(cat, true);
  //     api.fnPostForm(urls.WP_SEARCH_TAG_FROM_FILTER_PANE, { cat: [cat], filter: filter, source: Const.SEARCH_TAG_FROM_FILTER_PANE_FILTERPAN })
  //       .then(rs => {
  //         const selTags = allTags.flatMap(cat1 => (cat1.tags ?? []).filter(tag => cat1.category === cat && tag.selected));
  //         const selIds = selTags.map(x => x.tagId);
  //         const newTags = rs.filter((r: any) => !selIds.includes(r.tagId));
  //         const mergeTags = [...selTags, ...newTags];
  //         setAllTags(prev => prev.map(t => t.category === cat ? { ...t, tags: mergeTags } : t));
  //         setTagSearching(cat, false);
  //       })
  //       .catch(e2 => {
  //         Utils.HandleException(e2, true);
  //         setTagSearching(cat, false);
  //       });
  //   } catch (e) {
  //     Utils.HandleException(e, true);
  //   }
  // }

  const onSearchTag = useCallback((cat: string, filter: string) => {
    try {
      const api = new APIClient();

      setTagSearching(cat, true);

      api.fnPostForm(
        urls.WP_SEARCH_TAG_FROM_FILTER_PANE,
        { wpMode, cat: [cat], filter, source: Const.SEARCH_TAG_FROM_FILTER_PANE_FILTERPAN }
      )
        .then(rs => {
          setAllTags(prev => {
            // selected tags from previous state
            const selTags = prev
              .flatMap(c => (c.tags ?? []).filter(t => c.category === cat && t.selected));

            const selIds = selTags.map(x => x.tagId);

            const newTags = rs.filter((r: any) => !selIds.includes(r.tagId));
            const merged = [...selTags, ...newTags];

            return prev.map(c =>
              c.category === cat ? { ...c, tags: merged } : c
            );
          });

          setTagSearching(cat, false);
        })
        .catch(e => {
          Utils.HandleException(e, true);
          setTagSearching(cat, false);
        });
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }, [setTagSearching]);   // stable dependency  

  const fnApplySelectedTagId = useCallback((catParm: string, tagId: number, tagName: string) => {
    let fixedCat = catParm === Const.WP_CAT_EMP_FROM_BROWSE
      ? Const.WP_CAT_EMP
      : catParm;

    const tagCat = allTags.find(t => t.category === fixedCat);
    const isMultiSel = tagCat?.isMultiSel;

    const found = tagFilterSelected.some(t => t.tagId === tagId);

    let updated = tagFilterSelected;

    if (!isMultiSel) {
      updated = updated.filter(t => t.category !== fixedCat);
    } else if (found) {
      updated = updated.filter(t => t.tagId !== tagId);
    }

    if (!found) {
      // extract from allTags
      const existingTags = allTags.flatMap(cat =>
        (cat.tags ?? []).filter(t => t.tagId === tagId).map(x => ({
          ...x,
          category: cat.category,
          faColor: cat.faColor,
          bgColor: cat.bgColor,
          faIcon: cat.faIcon
        }))
      );

      if (existingTags.length > 0) {
        updated = [...updated, ...existingTags];
      } else if (catParm === Const.WP_CAT_EMP_FROM_BROWSE) {
        updated = [
          ...updated,
          {
            category: fixedCat,
            tagId,
            name: tagName,
            selected: null,
            faColor: tagCat?.faColor ?? null,
            bgColor: tagCat?.bgColor ?? null,
            faIcon: tagCat?.faIcon ?? null,
          }
        ];
      }
    }

    dispatch(setFilterSelected(wpMode, updated, undefined));

  }, [allTags, tagFilterSelected]);


  // const onClickTag = (catParm: string, tagId: number, tagName: string) => {
  //   try {
  //     let cat = catParm;
  //     if (cat === Const.WP_CAT_EMP_FROM_BROWSE) {
  //       cat = Const.WP_CAT_EMP;
  //     }
  //     fnApplySelectedTagId(catParm, tagId, tagName);
  //     setAllTags(prev =>
  //       prev.map(t =>
  //         t.category === cat
  //           ? {
  //             ...t,
  //             tags: (t.tags ?? []).map(t2 =>
  //               t2.tagId === tagId
  //                 ? {
  //                   ...t2,
  //                   selected: !t2.selected
  //                 }
  //                 : {
  //                   ...t2,
  //                   selected: t.isMultiSel ? t2.selected : false
  //                 }
  //             )
  //           }
  //           : t
  //       )
  //     );
  //   } catch (e) {
  //     Utils.HandleException(e, true);
  //   }
  // }

  const onClickTag = useCallback((catParm: string, tagId: number, tagName: string) => {
    try {
      let fixedCat = catParm === Const.WP_CAT_EMP_FROM_BROWSE
        ? Const.WP_CAT_EMP
        : catParm;

      // const tagClick = allTags.find(x => x.category == catParm)?.tags?.find(t => t.tagId == tagId);

      fnApplySelectedTagId(catParm, tagId, tagName);

      setAllTags(prev =>
        prev.map(t =>
          t.category === fixedCat
            ? {
              ...t,
              tags: (t.tags ?? []).map(t2 =>
                t2.tagId === tagId
                  ? { ...t2, selected: !t2.selected }
                  : { ...t2, selected: t.isMultiSel ? t2.selected : false }
              )
            }
            : t
        )
      );
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }, [fnApplySelectedTagId]);


  // const onClickMuliSel = (cat: string) => {
  //   try {
  //     const isMultiSelNew = !allTags.find(t => t.category === cat)?.isMultiSel;
  //     if (isMultiSelNew == false) {
  //       const update2 = (tagFilterSelected ?? []).filter(t => t.category !== cat);
  //       dispatch(setFilterSelected(update2, undefined));
  //     }
  //     setAllTags(prev =>
  //       prev.map(eCat =>
  //         eCat.category === cat
  //           ? {
  //             ...eCat,
  //             isMultiSel: !eCat.isMultiSel,
  //             tags: !eCat.isMultiSel
  //               ? eCat.tags
  //               : (eCat.tags ?? []).map(tp => ({ ...tp, selected: false }))
  //           }
  //           : eCat)
  //     );
  //   } catch (e) {
  //     Utils.HandleException(e, true);
  //   }
  // }

  const onClickMuliSel = useCallback((cat: string) => {
    try {
      const current = allTags.find(t => t.category === cat);
      if (!current) return;

      const willBeMultiSel = !current.isMultiSel;

      if (!willBeMultiSel) {
        const updatedSelected = (tagFilterSelected ?? []).filter(t => t.category !== cat);
        dispatch(setFilterSelected(wpMode, updatedSelected, undefined));
      }

      setAllTags(prev =>
        prev.map(e =>
          e.category === cat
            ? {
              ...e,
              isMultiSel: willBeMultiSel,
              tags: willBeMultiSel
                ? e.tags
                : (e.tags ?? []).map(tp => ({ ...tp, selected: false })),
            }
            : e
        )
      );
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }, [allTags, tagFilterSelected, dispatch]);



  // const onClickMatchedAll = (cat: string, matchedAll: boolean) => {
  //   try {
  //     setAllTags(prev => prev.map(t => t.category === cat ? { ...t, tagMatchedAll: matchedAll } : t))
  //   } catch (e) {
  //     Utils.HandleException(e, true);
  //   }
  // }
  const onClickMatchedAll = useCallback((cat: string, matchedAll: boolean) => {
    try {
      setAllTags(prev =>
        prev.map(t =>
          t.category === cat
            ? { ...t, tagMatchedAll: matchedAll }
            : t
        )
      );
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }, []);


  const [toggleSearch, setToggleSearch] = useState<boolean>(false);
  // const fnToggleSearch = () => {
  //   setToggleSearch(prev => !prev);
  // }
  const fnToggleSearch = useCallback(() => {
    setToggleSearch(prev => !prev);
  }, []); // no dependencies needed  


  const onClickOption = useCallback((cat: string, type: string, value: any) => {
    try {
      setAllTags(prev =>
        prev.map(eCat =>
          eCat.category !== cat
            ? eCat
            : {
              ...eCat,
              empFilterType:
                type === "WpEmpFilterType"
                  ? toNumber(value)
                  : eCat.empFilterType,
            }
        )
      );

      fnToggleSearch();
    } catch (e) {
      Utils.HandleException(e, true);
    }
  },
    [fnToggleSearch]
  );



  /* 20250612 Not use because when searching no result, the selected tag is clear, use selected when click instead
  useEffect(() => {
    const sel = allTags.flatMap(cat => (cat.tags ?? []).filter(tag => tag.selected)).map(m2 => m2.tagId);
    const sel2 = allTags.flatMap(cat => (cat.tags ?? []).filter(tag => tag.selected)
      .map(nw => ({
        ...nw,
        faColor: cat.faColor,
        bgColor: cat.bgColor,
        faIcon: cat.faIcon,
      })));
  
    dispatch(setFilterSelected(sel2));
  
    setSelTagIds(prevSel => {
      if (!isEqual(prevSel, sel)) {
        return sel;
      }
      return prevSel;
    });
  }, [allTags, dispatch]);
  */

  useEffect(() => {
    onSearchTitle(false, "Filter Changed");
    //}, [tagFilterSelected, /*selTagIds,*/ filterUnread, filterNotClose, tagCatMatchAll, toggleSearch]);
  }, [tagFilterSelected, /*selTagIds,*/ filterUnread, filterTaskDueMode, filterNotClose, tagCatMatchAll, toggleSearch, taskStatusFilter]); // 20260114

  // 20260721 "share filter between wp/task" setting: when keyword changes in the other mode and
  // sharing is on, this mode's keyword is mirrored into keywordWp/keywordTk (see wpSlice SET_KEYWORD).
  // Only sync the local textbox display here - do NOT trigger a search, since this fires on every
  // keystroke of the other mode's textbox. Search only happens from Enter / the search icon click.
  useEffect(() => {
    if (!shareFilterWpTask) return;
    if (keywordFromStore === keywordRef.current) return;
    setKeyword(keywordFromStore);
  }, [keywordFromStore, shareFilterWpTask]);

  // 20260724 when the other mode performs an actual search (Enter / search icon) while sharing is
  // on, wpSlice bumps this mode's searchTrigger counter (see SET_KEYWORD). Reload this mode's list
  // in the background now, using its own current filters, so switching tabs shows fresh results.
  useEffect(() => {
    if (isFirstSearchTriggerRun.current) {
      isFirstSearchTriggerRun.current = false;
      return;
    }
    if (!shareFilterWpTask) return;
    const empFilterType = allTags.find(e => e.category === Const.WP_CAT_EMP)?.empFilterType ?? WpEmpFilterType.Poster;
    const selTagIds2 = (tagFilterSelectedRef.current ?? []).map(t => t.tagId);
    const memberRole = Utils.GetMemberRoleFromStorage(wpMode);
    const sortMode = Utils.Conf_WorkPlaceSortMode(wpMode);
    dispatch(loadPostTitleActionV2(
      wpMode, keywordFromStore, [], memberRole, selTagIds2, filterUnreadRef.current, filterNotCloseRef.current, empFilterType, tagCatMatchAllRef.current, "Search triggered from other mode", taskStatusFilterRef.current,
      null, null, null, null, null, null, null, filterTaskDueModeRef.current, sortMode
    ));
  }, [searchTriggerFromStore]);


  useEffect(() => {
    const onMouseDown = (event: MouseEvent) => {
      try {
        if (divRefFilter.current) {
          const computedStyle = window.getComputedStyle(divRefFilter.current);
          const isAbsolute = computedStyle.position === "absolute";
          if (isAbsolute && divRefFilter.current.classList.contains("workplace-filter-show")) {
            const isClickOutside = !divRefFilter.current.contains(event.target as Node);
            onToggleFilterPane();
            // if (isClickOutside){
            //   divRefFilter.current.classList.remove("workplace-filter-show");
            //   divRefFilter.current.classList.add("workplace-filter-hide");
            // }
          }
        }
      } catch (e) {
        Utils.HandleException(e, true);
      }
    }

    // document.addEventListener('mousedown', onMouseDown);
    return () => {
      // document.removeEventListener('mousedown', onMouseDown);
    }
  }, []);


  const onFilterUnreadChanged = useCallback((filterUnreadChecked: boolean) => {
    setFilterUnread(filterUnreadChecked);
    if (filterUnreadChecked) {
      dispatch(setFilterSelected(wpMode, undefined, false));
    }
    Utils.Conf_WorkPlaceFilterUnread(wpMode, filterUnreadChecked);
  }, [dispatch]);

  const onFilterNotClose = useCallback((val: boolean) => {
    dispatch(setFilterSelected(wpMode, undefined, val));
  }, [dispatch]);

  const onFilterTaskDueMode = useCallback((val: WpFilterTaskDueMode) => {
    setFilterTaskDueMode(prev => prev === val ? WpFilterTaskDueMode.None : val);
  }, [dispatch])

  const divRefFilter = useRef<HTMLDivElement>(null);

  const onClickTaskStatus = (taskStatus: TaskStatus) => {
    // if (taskStatusFilter.some(x => x == taskStatus)) {
    //   dispatch(setTaskStatusFilter(null));
    // } else {
    //   dispatch(setTaskStatusFilter(taskStatus));
    // }
    dispatch(setTaskStatusFilter(taskStatus));
  }


  useEffect(() => {
    if (!allTags.length) return;

    setAllTags(prev =>
      prev.map((cat: WorkPlaceCatFilter) => ({
        ...cat,
        tags: !cat.tags ? cat.tags : cat.tags.map((tag: WorkPlaceTagFilter) => {
          const hit = tagUnreadOnSignalR.find(u =>
            u.wpMode === wpMode &&
            u.tagId === tag.tagId &&
            u.memberId === curUserId/* && u.unreadCount != tag.unreadCount*/
          );

          return hit
            ? { ...tag, unreadCount: hit.unreadCount }
            : { ...tag, unreadCount: 0 };
        })
      }))
    );
  }, [tagUnreadOnSignalR]);

  return (
    <div className="workplace-container">
      <div className="workplace-header" >
        <div className="px-4 pt-3">
          {/* {tagUnreadOnSignalR.reduce((sum, item) => sum + (item.unreadCount ?? 0), 0)} */}
          {Title(curUserId, wpMode)}
          {/* <Title  /> */}
        </div>
        <div className="px-3 pt-2"  >
          <FilterControl keyword={keyword} onSearchTitle={(e) => onSearchTitle(e, "FilterControl")} onKeywordChange={onKeywordChange} searchInputRef={searchInputRef} />
          <WorkplaceFilterSel wpMode={wpMode} allTags={allTags} onFilterDel={onFilterDel} />
        </div>
      </div>

      <div className="ps-2 pe-0 pt-1 workplace-content-wrapper">
        {!showFilterPanel && (
          <div className="workplace-filter-open-tall hand hide-md-bellow" style={{ display: "none" }} onClick={onToggleFilterPane}>
            <i className="fas fa-angle-right fz-15"></i>
          </div>
        )}
        <div ref={divRefFilter} className={"workplace-filter " + cssWorkPlaceFilter} style={{ /*borderRight: "solid 1px gray", borderTop: "solid 1px gray"*/ }}>
          <>
            <WorkPlaceFilter
              onApplyFilter={onApplyFilter}
              allTags={allTags}
              onTagSelect={onTagSelect}
              onSearchTag={onSearchTag}
              onClickTag={onClickTag}
              onClickMuliSel={onClickMuliSel}
              onClickMatchedAll={onClickMatchedAll}
              filterUnRead={filterUnread}
              onFilterUnRead={onFilterUnreadChanged}
              filterNotClose={filterNotClose}
              onFilterNotClose={onFilterNotClose}
              onClickOption={onClickOption}
              onToggleCollapse={onToggleCollapse}
              tagFilterSelected={tagFilterSelected}
              wpMode={wpMode}
              onClickTaskStatus={onClickTaskStatus}
              taskStatusSelected={taskStatusFilter}
              filterTaskDueMode={filterTaskDueMode}
              onFilterTaskDueMode={onFilterTaskDueMode}
            ></WorkPlaceFilter>
            {/* <WorkPlaceFilter
              onApplyFilter={onApplyFilter} onClickTag={onClickTag} onClickMuliSel={onClickMuliSel} onClickMatchedAll={onClickMatchedAll}
              onTagSelect={onTagSelect} allTags={allTags} onSearchTag={onSearchTag}
              // filterUnRead={filterUnread} onFilterUnRead={(val) => { setFilterUnread(val); if (val) dispatch(setFilterSelected(undefined, false)); }}
              filterUnRead={filterUnread} onFilterUnRead={(val) => { onFilterUnreadChanged(val) }}
              filterNotClose={filterNotClose} onFilterNotClose={(val) => dispatch(setFilterSelected(undefined, val))}
              onClickOption={onClickOption} onToggleCollapse={onToggleCollapse}
            /> */}
          </>
        </div>
        <div className="workplace-title" style={{ /*borderTop: "solid 1px gray" */ }}>
          <WorkplaceTitle onToggleFilterPane={onToggleFilterPane} onClickSearch={onClickSearch} onClickTitle={onClickTitle} onClickUnreadIcon={onClickUnreadIcon} wpMode={wpMode} />
        </div>
      </div>
    </div>
  )
}
export default Index;